import { createSelector } from '@reduxjs/toolkit';

import { selectCheapestDeliveryOptionPrice } from 'src/redux/delivery/selectors/selectCheapestDeliveryOptionPrice';
import { selectProductDeliveryByEvent } from 'src/redux/product/selectors';

export const selectDeliveryByEventCost = createSelector(
  [selectCheapestDeliveryOptionPrice, selectProductDeliveryByEvent],
  (cost, deliveryByEvent) => {
    if (!deliveryByEvent?.arriveByEvent || cost == null) {
      return 'not set';
    }

    return cost || 'free';
  },
);
